export default {
  namespaced: true,

  state: () => ({}),

  mutations: {
    setBanners(state, { savePath, banners = [] } = {}) {
      state[savePath] = banners.sort((a, b) => a.sort - b.sort);
    },
  },

  actions: {
    async getBanners({ commit, rootGetters }, { slots = [], withCategory = true } = {}){
      let response;
      const args = [slots];

      if (withCategory) {
        args.push(rootGetters['category/categoryUrl']);
      }

      try {
        response = await this.$api.getBanners(...args);
      } catch(e) {
        console.error(e);
      }

      for (let key in response) {
        commit('setBanners', {
          savePath: key,
          banners: response[key]
        })
      }
    }
  },
}
